<template>
    <v-container fluid grid-list-xl class="px-3" style="margin-top: 20px !important;">
        <div class="d-flex-inline mt-3 mb-3" style="align-items: center;">
            <v-icon small color="primary" class="mr-2">chevron_left</v-icon>
            <a href="" @click.prevent="voltarParaOrigem" class="primary--text" style="text-decoration: none">Voltar</a>
        </div>

        <tiny-editor :documento="documentoADesentranhar"
                     :compraDiretaParcial="compraDiretaParcial"
                     @eventoDesentranhar="processarEventoDesentranhamento"/>
    </v-container>
</template>
<script>
import TinyEditor from './components/TinyEditor.vue'
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'

export default {
    name: 'DesemtranhamentoDocumento',
    components: { TinyEditor },
    computed: {
        ...mapState(['rotaVolta', 'documentoDesentranhamento', 'resumoCompraDireta']),
        documentoADesentranhar() {
            return this.documentoDesentranhamento
        },
        compraDiretaParcial() {
            return {
                processo: this.resumoCompraDireta.processo,
                situacao: this.resumoCompraDireta.situacao,
                id: this.resumoCompraDireta.id
            }
        }

    },
    async mounted() {
        await this.buscarInfosDoDocumentoADesentranhar()
    },
    methods: {
        voltarParaOrigem() {
            history.back()
        },
        async buscarInfosDoDocumentoADesentranhar() {

            if(!this.documentoADesentranhar.documentoId) {
                const requestData = {
                    compraDiretaId: this.$route.params.id,
                    documentoId: this.$route.params.documentoId,
                    documentoVirtualizadoId: this.$route.query.token,
                    tipo: this.$route.params.tipoDocumento
                }
                await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_INFOS_DOC_DESENTRANHAMENTO, requestData)
            }

            if(!this.resumoCompraDireta.id)
                await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, this.$route.params.id)
        },
        async processarEventoDesentranhamento(conteudoHtml, idAutoSave) {
            const data = {
                compraDiretaId: this.$route.params.id,
                documentoId: this.$route.params.documentoId,
                documentoVirtualizadoId: this.$route.query.token,
                tipo: this.$route.params.tipoDocumento,
                pessoaId: this.$route.query.fornecedorId,
                conteudoHtml: conteudoHtml
            }

            const resp = await this.$store.dispatch(actionTypes.COMPRADOR.DESENTRANHAR_DOCUMENTO_VIRTUALIZADO, data)

            if(resp.desentranhadoComSucesso === true){
                this.mostrarNotificacaoSucesso('Documento desentranhado com sucesso! Será redicionado para a listagem de documentos.')
                localStorage.removeItem(idAutoSave +  'draft')
                localStorage.removeItem(idAutoSave +  'time')
                this.voltarParaOrigem()
            }
        },
    }
}
</script>